module.exports = __webpack_public_path__ + "static/title.e9527efa.png";